module.exports = __webpack_public_path__ + "static/media/0317_Medium.73414c38.jpg";